import React, { useState } from "react";
import "../Styles/Projects.css";
import { logosList } from "../utils/logosList";

const Logos = () => {
  const [selectedLogo, setSelectedLogo] = useState(null);

  const openModal = (logo) => setSelectedLogo(logo);
  const closeModal = () => setSelectedLogo(null);

  return (
    <div className="projects-page">
      <h1 style={{ textAlign: "center", fontFamily: "roboto", padding: "20px" }}>Our Client Logos</h1>
      <div className="projects-grid">
        {logosList.map((logo, index) => (
          <div key={index} className="project-card">
            <img src={logo.image} alt={logo.title} className="project-image" />
            <div className="project-details">
              <h2>{logo.title}</h2>
              <p>{logo.description}</p>
              <button className="project-link" onClick={() => openModal(logo)}>
                View Logo
              </button>
            </div>
          </div>
        ))}
      </div>

      {selectedLogo && (
        <div className="modal-overlay" onClick={closeModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <img src={selectedLogo.image} alt={selectedLogo.title} className="modal-image" />
            <h2>{selectedLogo.title}</h2>
            <p>{selectedLogo.description}</p>
            <button onClick={closeModal} className="close-btn">Close</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Logos;
